import BankingDisclosureComponent from "./BankingDisclosureComponent";

export default BankingDisclosureComponent;
